export default {
    aerial_hazard: {
        name: "Aerial Hazard",
        url: "nwcg_air_ops/aerial_hazard",
    },
    airport: {
        name: "Airport",
        url: "nwcg_air_ops/airport",
    },
    aviation_check_point: {
        name: "Aviation Check Point",
        url: "nwcg_air_ops/aviation_check_point",
    },
    helibase: {
        name: "Helibase",
        url: "nwcg_air_ops/helibase",
    },
    helispot: {
        name: "Helispot",
        url: "nwcg_air_ops/helispot",
    },
    mobile_retardant_base: {
        name: "Mobile Retardant Base",
        url: "nwcg_air_ops/mobile_retardant_base",
    },
    sling_site: {
        name: "Sling Site",
        url: "nwcg_air_ops/sling_site",
    },
    unimproved_landing_area: {
        name: "Unimproved Landing Area",
        url: "nwcg_air_ops/unimproved_landing_area",
    },
    uas_launch_and_recovery: {
        name: "UAS Launch And Recovery",
        url: "nwcg_air_ops/uas_launch_and_recovery",
    },
}
